import React from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    AreaChart,
    Area,
} from "recharts";
import { Loader } from "./Loader";

const example_data = [
    {
        name: "10/21",
        mintuple: 1,
        cumul: 1
    },
    {
        name: "11/21",
        mintuple: 3,
        cumul: 3
    },
    {
        name: "12/21",
        mintuple: 2,
        cumul: 5.1
    },
    {
        name: "01/22",
        mintuple: 5,
        cumul: 10.3
    }
];

/**
 * props:
 *      - data  (if no provided, will display some example data)
 *      - loading  boolean, true to display an empty graph, ex while loading
 */
export default function ChartMintuple(props) {
    var data = props.data || example_data
    if (props.loading) {
        data = [{
            name: "chargement...",
            mintuple: 0,
            cumul: 0,
        }]
    }

    const myFormatter = (val) => {
        return val + "%";
    };
    /* <AreaChart  
            width={500}
            height={300}
            data={data}
            margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5
            }}
    */
    let _1vh_in_pixels = Math.round(window.innerHeight / 100)
    let _1vw_in_pixels = Math.round(window.innerWidth / 100)
    // the Slide wrapper caps content at 800px maxWidth, so don't exceed it
    let chart_width = Math.min(70 * _1vw_in_pixels, 800)

    return (
        <center>
            {props.loading ?
                <center><Loader linearIcon /></center>
                : null}
            <AreaChart
                width={chart_width}
                height={40 * _1vh_in_pixels}
                data={data}
                margin={{
                    top: 5,
                    right: 50,
                    left: -10,
                    bottom: 5
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis yAxisId="left" tickFormatter={myFormatter} />
                {/* <YAxis yAxisId="right" stroke="#8884d8" orientation="right" /> // second Y-axis*/}
                <Tooltip formatter={myFormatter} labelStyle={{ color: "black" }} />
                <Legend color="white" />
                <Area
                    type="monotone"
                    dataKey="cumul"
                    stroke="#ffc658"
                    yAxisId="left"
                    fill="#ffc658"
                />
                {/* <Area
                    type="monotone"
                    dataKey="cumul"
                    stroke="#8884d8"
                    yAxisId="left"
                    fill="#8884d8"
                />
                <Area
                    type="monotone"
                    dataKey="mintuple"
                    stroke="#b78e3f"
                    // activeDot={{ r: 8 }}
                    yAxisId="left"
                    fill="#ffc658"
                /> */}
            </AreaChart>
        </center>
    );
}
